<template>
  <div class="text-center"> 
    <v-btn
      :loading="loading3"
      :disabled="loading3"
      color="blue-grey"
      class="ma-2 white--text"
      @click="reset"
    >
      Reset
      <v-icon right dark>fas fa-sync</v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    props: ["emitter", "ikey", "sleepTime","getData", "putData"],
    data () {
      return {
          dateValue:null,
          loader:null,
        loading3: false
      }
    },
    methods: {
      reset () {
          const l = 'loading3'
        this[l] = !this[l]

                if (this.ikey && l !==null ) {
        this.putData(this.ikey, new Date());
      }
        
        if (this.emitter !== undefined) {
            this.emitter.trigger("process");
        }
        setTimeout(() => (this[l] = false), this.sleepTime)

      },
    },
      mounted() {
    if (this.getData !== undefined) {
      this.dateValue = this.getData(this.ikey);
    }
  },
  }
</script>

<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>